import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import API from 'services/api/index';
import QUERY_KEYS from 'services/api/queryKeys';
import { GroupedRoomStatus } from 'services/api/type/room.type';

export const useGetRoomStatus = (startDate: string, endDate: string) => {
  const { data, status, isLoading, isFetching } = useQuery({
    queryKey: [QUERY_KEYS.KEY_ROOM, QUERY_KEYS.GET_ROOM_STATUS],
    queryFn: () => API.room.getRoomStatus(startDate, endDate)
  });

  const groupedData = useMemo(() => {
    if (!data) return data;

    const groupedRooms: GroupedRoomStatus[] = [];
    const processedBookingIds = new Set<number>();

    data.forEach(room => {
      // if (room.booking_line?.booking_id) {
      //   if (!processedBookingIds.has(room.booking_line.booking_id)) {
      //     const roomsWithSameBooking = data.filter(
      //       otherRoom => otherRoom.booking_line?.booking_id === room.booking_line.booking_id
      //     );

      //     if (roomsWithSameBooking.length > 1 || room.booking_line.group_master_id) {
      //       roomsWithSameBooking.forEach(roomToAdd => {
      //         const groupedRoom: GroupedRoomStatus = {
      //           ...roomToAdd,
      //           group: {
      //             booking_id: room.booking_line.booking_id,
      //             moved_booking_id: room.booking_line.moved_booking_id,
      //             group_name: room.booking_line.group_name,
      //             group_master_id: room.booking_line.group_master_id,
      //             group_master_name: room.booking_line.group_master_name
      //           }
      //         };
      //         groupedRooms.push(groupedRoom);
      //       });
      //       processedBookingIds.add(room.booking_line.booking_id);
      //     } else {
      //       groupedRooms.push(room);
      //     }
      //   }
      // } else {
      //   groupedRooms.push(room);
      // }

      if (room.booking_line?.moved_booking_id) {
        if (!processedBookingIds.has(room.booking_line.moved_booking_id)) {
          const roomsWithSameBooking = data.filter(
            otherRoom =>
              otherRoom.booking_line?.moved_booking_id === room.booking_line.moved_booking_id
          );

          if (roomsWithSameBooking.length > 1 || room.booking_line.group_master_id) {
            roomsWithSameBooking.forEach(roomToAdd => {
              const groupedRoom: GroupedRoomStatus = {
                ...roomToAdd,
                group: {
                  booking_id: room.booking_line.booking_id,
                  moved_booking_id: room.booking_line.moved_booking_id,
                  group_name: room.booking_line.group_name,
                  group_master_id: room.booking_line.group_master_id,
                  group_master_name: room.booking_line.group_master_name
                }
              };
              groupedRooms.push(groupedRoom);
            });
            processedBookingIds.add(room.booking_line.moved_booking_id);
          } else {
            groupedRooms.push(room);
          }
        }
      } else {
        groupedRooms.push(room);
      }
    });

    return groupedRooms;
  }, [data]);

  return {
    data: groupedData,
    status,
    isLoading,
    isFetching
  };
};
